export default __webpack_public_path__ + "static/media/familia_2.b5f85a6b.jpg";